module.exports = __webpack_public_path__ + "static/media/slide2.0953f78a.svg";